import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import dayjs from "dayjs"
import { LuCalendar } from "react-icons/lu"
import { userTimeZone } from "../../utils/date"

const CalendarIcon = () => <LuCalendar size={18} className="text-text-secondary" />

const DateTimeField = ({
  parentClassName,
  width,
  value,
  onChange,
  label,
  disablePast = true,
  disabled = false,
  height,
  errorMsg
}) => {
  const hasError = Boolean(errorMsg)
  const zone = Intl.DateTimeFormat().resolvedOptions().timeZone

  return (
    <div className={parentClassName}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <div className="flex flex-col">
          <div className={`mb-2 flex justify-start flex-col text-[13px] leading-5 ${hasError ? "text-primary-static-error-600" : "text-text-secondary"}`}>
            {label}
          </div>
          <DateTimePicker
            label={false}
            disabled={disabled}
            disablePast={disablePast}
            timezone={userTimeZone}
            className={`calendar ${width}`}
            value={value ? dayjs(value) : null}
            onChange={(newValue) => onChange(newValue)}
            format="MM-DD-YYYY hh:mm A"
            ampm
            slots={{ openPickerIcon: CalendarIcon }}
            slotProps={{
              popper: { disablePortal: true },
              textField: { helperText: `Your time zone: ${zone}` }
            }}
            sx={{
              '& > div': {
                height: height ? height : "56px",
                borderRadius: '8px !important'
              },
              'fieldset': {
                top: 0,
                border: '1px solid',
                height: height ? height : '56px',
                borderColor: hasError ? '#F04438' : 'var(--color-divider)',
                '--tw-border-opacity': '1',
                'legend': {
                  display: 'none'
                }
              }
            }}
          />
        </div>
      </LocalizationProvider>

      {hasError && <p className="text-primary-static-error-600 text-sm mt-1">{errorMsg}</p>}
    </div>
  )
}

export default DateTimeField
